<template>
    <div class="breadcrumbModule">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="background: #f9f9f9;">
            <el-breadcrumb-item v-for="(item, index) in navData" :key="index" :class="{'navEnd': navData.length - 1 == index}" :to="item.to">{{ item.title }}</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>

<script>
export default {
    props: {
        navData: [],
    }
}
</script>

<style lang="scss">
@import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/components/module/breadcrumb/index.vue